import { render, staticRenderFns } from "./CourseShow.vue?vue&type=template&id=0bc4b462&scoped=true"
import script from "./CourseShow.vue?vue&type=script&lang=js"
export * from "./CourseShow.vue?vue&type=script&lang=js"
import style0 from "./CourseShow.vue?vue&type=style&index=0&id=0bc4b462&prod&lang=scss&scoped=true"
import style1 from "./CourseShow.vue?vue&type=style&index=1&id=0bc4b462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4b462",
  null
  
)

export default component.exports